
export class FileUtils {


    public static async readFile(file: File) {
        return new Promise((resolve) => {
            const reader = new FileReader()
            reader.onloadend = () => {
                if (reader.result)
                    resolve(reader.result.toString().replace(/^data:(.*,)?/, ''))
            }
            reader.readAsDataURL(file)
        })
    }

    public static handleFileInput(event: any, mimeType4Check: string) {

        if (event) {
            var mimeType = event.target.files[0].type;
            if (mimeType.match(mimeType4Check) == null) {
                return -1;
            }
            else {
                return event.target.files[0];
            }
        }
    }

    public static convertBase64ToBlob(base64: string, contentType:string) {
        const decodedData = window.atob(base64);

        const uInt8Array = new Uint8Array(decodedData.length);

        for (let i = 0; i < decodedData.length; ++i) {
            uInt8Array[i] = decodedData.charCodeAt(i);
        }

        return new Blob([uInt8Array], { type: contentType });
    }
}

